import React, { useState } from 'react';

import css from '../../WidgetPage/WidgetPage.module.scss';

const VerifyIdentityExplainer = props => {
  const [showModal, setShowModal] = useState(false);

  let text =
    "To help the government fight the funding of terrorism and money laundering activities, federal law requires Greenlight to obtain, verify, and record information that identifies each person who opens an account. When you open an account, Greenlight asks for your name, address, date of birth, and other information that allows us to identify you. We may also ask to see your driver's license and other identifying information.";
  if (props.explainerType === 'prove') {
    text =
      'By providing your date of birth, Greenlight will attempt to find your personal information like your name, address and the last four digits of your social security number to expedite the registration process.';
  }

  return (
    <>
      {showModal && (
        <div data-e2e="verify-container" className={css.verifyInfoContainer}>
          <div data-e2e="verify" className={css.verifyInfo}>
            <button onClick={() => setShowModal(false)}>
              <img
                src="/static/icon-menu-btn-close.svg"
                alt="Close Icon"
                data-e2e="verify-close"
                data-testid="verify-close"
              />
            </button>
            <img
              src="/static/verify-image.png"
              alt="Verify Identity"
              data-e2e="verify-image"
            />
            <p data-e2e="verify-text">{text}</p>
          </div>
        </div>
      )}
      <br />
      <a
        onClick={() => setShowModal(true)}
        data-e2e="verify-open"
        className={css.moreInfo}
      >
        Why are we asking this?
      </a>
    </>
  );
};

export default VerifyIdentityExplainer;
